import { createFileRoute } from "@tanstack/react-router";
import HashGeneratorPage from "@/pages/HashGeneratorPage";

export const Route = createFileRoute("/tools/hash-generator")({
  component: HashGeneratorPage,
});
